import React from 'react';
import { Container } from 'reactstrap';

import { Intl } from 'components';

export default React.memo( ( {
  title, className, children, values = {},
} ) => (
  <Container className={className}>
    {title
    && (
    <div className="text-center">
      <span className="text-mp-orange-1 title">
        <Intl id={title} values={values}/>
      </span>
    </div>
    )}
    {children}
  </Container>
) );
